<template>
  <div class="brother">
    <div class="thumb">
      <img v-bind:src="avatar" />
    </div>
    <div>
      <div>
        <strong>{{name}}</strong>
        ({{memberId}})
      </div>
      <div><i>{{title}}</i></div>
      <div>{{adress}}</div>
      <div>{{zip}}</div>
      <div>{{phone}}</div>
      <div>{{email}}</div>
      <div>{{birthday}}</div>
      <div>{{initiated}}</div>
      <div>{{sponsor}}</div>
    </div>
  </div>
</template>

<script>
import imgUrl from '@/assets/img/avatar.jpg'
export default {
  name: "brother",
  props: {
    brother: Object,
    user: Object
  },
  computed: {
    name() {
      const user = this.brother.userData;
      return user.first_name + " " + user.last_name;
    },
    memberId() {
      return this.brother.memberid;
    },
    title() {
      return this.brother.title;
    },
    adress() {
      return this.brother.adress;
    },
    zip() {
      const zipcode = this.brother.zipcode.toString();
      return (
        zipcode.slice(0, 3) +
        " " +
        zipcode.slice(3, zipcode.length) +
        " " +
        this.brother.city
      );
    },
    phone() {
      return this.brother.mobile;
    },
    email() {
      return this.brother.email;
    },
    birthday() {
      return "Födelsedag: " + this.brother.birthday;
    },
    initiated() {
      return "Invigd: " + this.brother.initiated;
    },
    sponsor() {
      const sponsor = this.brother.sponsorData;
      if(this.brother.altsponsor) return "Fadder: " + this.brother.altsponsor;
      if (!sponsor) return "Fadder: ej angiven";
      return "Fadder: " + sponsor.first_name + " " + sponsor.last_name;
    },
    avatar() {
        const url = this.brother.imgurl
        if(url)
            return this.brother.imgurl;
        return imgUrl;
  }
}
};
</script>
<style scoped>
.brother {
  text-align: left;
  display: flex;
  flex-direction: row;
  height: 160px;
  margin-top: 10px;
  float:none;
}
.brother:nth-child(4n+2){
  page-break-after: always;
}
.brother:nth-child(3n+1){
}
.thumb img {
  height: 150px;
  margin-right: 10px;
}
</style>